<template>
  <div class="pie_chart"></div>
</template>

<script>
import Highcharts from "highcharts/highstock";
export default {
  name: "PieChart",
  props: {
    seriesData: {
      type: Array,
      required: true,
    },
    titleText: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      chart: null,
    };
  },
  created() {
  },
  mounted() {
    this.initChart();
    this.chart.showLoading();
  },
  methods: {
    initChart(){
      let that = this;
      this.chart = new Highcharts.Chart(this.$el, {
        credits: {
          enabled: false
        },
        chart: {
          spacing : [20, 0 , 20, 0]
        },
        title: {
          // floating:true,
          text: null,
        },
        tooltip: {
          pointFormat: '{series.name}: <b>{point.percentage:.1f}%</b>'
        },
        plotOptions: {
          pie: {
            allowPointSelect: true,
            cursor: 'pointer',
            dataLabels: {
              enabled: false,
            },
            showInLegend: true,
            colors: ['rgb(24,146,253)', 'rgb(74,210,102)', 'rgb(251,163,73)', 'rgb(180,118,238)', 'rgb(252,236,91)'].reverse(),
            point: {
              // events: {
              //   mouseOver: function(e) {  // 鼠标滑过时动态更新标题
              //     // 标题更新函数，API 地址：https://api.hcharts.cn/highcharts#Chart.setTitle
              //     chart.setTitle({
              //       text: e.target.name+ '\t'+ e.target.y + ' %'
              //     });
              //   }
                //,
                // click: function(e) { // 同样的可以在点击事件里处理
                //     chart.setTitle({
                //         text: e.point.name+ '\t'+ e.point.y + ' %'
                //     });
                // }
              // }
            },
          }
        },
        series: [{
          type: 'pie',
          innerSize: '80%',
          name: that.titleText,
          data: that.seriesData,
        }]
      }, function(c) { // 图表初始化完毕后的会掉函数
            // 环形图圆心
            var centerY = c.series[0].center[1],
                titleHeight = parseInt(c.title.styles.fontSize);
            // 动态设置标题位置
            c.setTitle({
              y:centerY + titleHeight/2
            });
          });
    },
  },
  watch: {
    seriesData: {
      handler(newValue) {
        this.chart.update({
          series: [{
            id: 'pie',
            data: newValue
          }]
        });
        this.chart.hideLoading();
      },
    },
  },
}
</script>

<style scoped>
.pie_chart{
  height: 250px;
}
</style>
